/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CertificateReorderDto } from '../../models/certificate-reorder-dto';

export interface CertificateAdminControllerReorderV1$Params {
      body: CertificateReorderDto
}

export function certificateAdminControllerReorderV1(http: HttpClient, rootUrl: string, params: CertificateAdminControllerReorderV1$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, certificateAdminControllerReorderV1.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

certificateAdminControllerReorderV1.PATH = '/api/v1/certificates/admin/reorder';
